import { ListItem, Box, Typography } from '@mui/material';

export default function ListFormItem({ label, children }: any) {
  return (
    <ListItem divider sx={{ px: 0, py: 1 }}>
      <Box width="33%" py={1.25}>
        <Typography variant="body2">{label}</Typography>
      </Box>
      <Box width="77%">{children}</Box>
    </ListItem>
  );
}
